// Single source of truth for the UI-key → canonical-timeframe
// mapping. The UI carries the legacy long form (`weekly`/`daily`/
// `hourly`) in routing/state, while the API surface and EventsTable
// vocabulary use the canonical short form (`1w`/`1d`/`1h`). Anywhere
// the conversion is needed, import from here — pre-2026-04-25 there
// were two private copies (one in `useBackendCycleEvents`, one in
// `api/cycles`) and bugbot rightly flagged the divergence risk.
export const TIMEFRAME_UI_TO_CANONICAL = {
  weekly: '1w',
  daily: '1d',
  hourly: '1h',
};

export const toCanonicalTimeframe = (tf) => {
  if (!tf) {
    return tf;
  }
  return TIMEFRAME_UI_TO_CANONICAL[tf] || tf;
};
